interface Props {
	className?: string;
	size?: number;
}

export const Chart: React.FC<Props> = ({ className, size }) => {
	return (
		<svg
			width={`${size ? `${size}` : '18'}`}
			height={`${size ? `${size}` : '18'}`}
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M16.3125 14.625C16.3125 14.7742 16.2532 14.9173 16.1477 15.0227C16.0423 15.1282 15.8992 15.1875 15.75 15.1875H2.25C2.10082 15.1875 1.95774 15.1282 1.85225 15.0227C1.74676 14.9173 1.6875 14.7742 1.6875 14.625V3.375C1.6875 3.22582 1.74676 3.08274 1.85225 2.97725C1.95774 2.87176 2.10082 2.8125 2.25 2.8125C2.39918 2.8125 2.54226 2.87176 2.64775 2.97725C2.75324 3.08274 2.8125 3.22582 2.8125 3.375V11.0173L6.35203 7.47703C6.40427 7.42473 6.46631 7.38324 6.5346 7.35494C6.60288 7.32663 6.67608 7.31206 6.75 7.31206C6.82392 7.31206 6.89712 7.32663 6.9654 7.35494C7.03369 7.38324 7.09573 7.42473 7.14797 7.47703L9 9.32977L12.7048 5.625H11.25C11.1008 5.625 10.9577 5.56574 10.8523 5.46025C10.7468 5.35476 10.6875 5.21168 10.6875 5.0625C10.6875 4.91332 10.7468 4.77024 10.8523 4.66475C10.9577 4.55926 11.1008 4.5 11.25 4.5H14.0625C14.2117 4.5 14.3548 4.55926 14.4602 4.66475C14.5657 4.77024 14.625 4.91332 14.625 5.0625V7.875C14.625 8.02418 14.5657 8.16726 14.4602 8.27275C14.3548 8.37824 14.2117 8.4375 14.0625 8.4375C13.9133 8.4375 13.7702 8.37824 13.6648 8.27275C13.5593 8.16726 13.5 8.02418 13.5 7.875V6.42023L9.39797 10.523C9.34573 10.5753 9.28369 10.6168 9.2154 10.6451C9.14712 10.6734 9.07392 10.6879 9 10.6879C8.92608 10.6879 8.85288 10.6734 8.7846 10.6451C8.71631 10.6168 8.65427 10.5753 8.60203 10.523L6.75 8.67023L2.8125 12.6077V14.0625H15.75C15.8992 14.0625 16.0423 14.1218 16.1477 14.2273C16.2532 14.3327 16.3125 14.4758 16.3125 14.625Z"
				fill="currentColor"
			/>
		</svg>
	);
};
